import { render, staticRenderFns } from "./ConfigureSettings.vue?vue&type=template&id=3a3ca649&scoped=true&"
import script from "./ConfigureSettings.vue?vue&type=script&lang=js&"
export * from "./ConfigureSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a3ca649",
  null
  
)

export default component.exports